import { escapeHTML } from './index.js';

/** Returns the indices of all matches of a regular expression in the text. */
var getIndices = function (text, exp) {
    var indices = [];
    // Clone the regular expression to reset its last index state.
    var exp2 = new RegExp(exp);
    exp2.lastIndex = 0;
    var match;
    while ((match = exp2.exec(text)) !== null) {
        indices.push([match.index, match.index + match[0].length - 1]);
        if (!exp2.global) {
            break;
        }
    }
    return indices;
};
/**
 * Highlights the given indices in a string by wrapping them in HTML tags.
 *
 * @param text The source text to highlight.
 * @param indices The parts of the text that should be highlighted.
 * @param tag The HTML element with which to wrap the highlighted parts.
 *
 * @returns An HTML string. Any HTML in the source text is escaped.
 */
var highlightText = function (text, indices, tag) {
    if (tag === void 0) { tag = "mark"; }
    var textArr = text.split("").map(escapeHTML);
    for (var i = indices.length - 1; i >= 0; i--) {
        var _a = indices[i], start = _a[0], end = _a[1];
        textArr.splice(end + 1, 0, "</" + tag + ">");
        textArr.splice(start, 0, "<" + tag + ">");
    }
    return textArr.join("");
};

export { getIndices, highlightText };
